module.exports = __webpack_public_path__ + "static/media/emmaAmarilla.523cbe80.png";